import { Request } from "../services/Requests";
const RequestBuilder = new Request.Builder("customerassist", "alexcustomerdata");

const service = {
    getCustomer(customerid: string): Promise<any> {
        const template = "/customer/{customerId}";
        return RequestBuilder.path(template, { customerId: customerid }).get();
    }
};

export default service;
